import { Star } from "lucide-react";
import { Reveal } from "./shared";

const STATS = [
  { value: "+10", label: "Anos de experiência" },
  { value: "+500", label: "Atendimentos realizados" },
  { value: "5", label: "Clientes satisfeitos", stars: true },
  { value: "24h", label: "Atendimento emergencial" },
];

export const Stats = () => (
  <section className="hero-fire bg-[var(--dark-bg)] py-16" data-testid="stats-section">
    <div className="mx-auto grid max-w-6xl grid-cols-2 gap-10 px-5 lg:grid-cols-4 lg:px-8">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.1} className="text-center">
          {s.stars ? (
            <div className="flex justify-center gap-1" data-testid={`stat-${i}`}>
              {[...Array(5)].map((_, j) => (
                <Star key={j} size={26} className="fill-[var(--primary)] text-[var(--primary)]" />
              ))}
            </div>
          ) : (
            <p className="font-display text-5xl font-extrabold text-[var(--primary)]" data-testid={`stat-${i}`}>
              {s.value}
            </p>
          )}
          <p className="mt-2 font-display text-sm font-semibold uppercase tracking-widest text-zinc-400">
            {s.label}
          </p>
        </Reveal>
      ))}
    </div>
  </section>
);
